export default dateAsText => dateObjectFromDayMonthYear(dateAsText.split('/'));

const dateObjectFromDayMonthYear = ([day, month, year]) => new Date(year, month - 1, day);
